import React, { useState, useContext, useEffect } from "react";
import { EquipmentContext } from "../useContext/context";

export default function VarOnlySection(
) {
    const { var_only, setVarOnly } = useContext(EquipmentContext);
    const [selectedOption, setSelectedOption] = useState(var_only?.type || "");
    const [terminalDetails, setTerminalDetails] = useState({
        model: var_only?.type === "terminal" ?  var_only?.model : "",
        serialNumber: var_only?.type === "terminal" ? var_only?.serial : "",
    });
    const [gatewayName, setGatewayName] = useState(var_only?.type === "gateway" ? var_only?.model : "");

    useEffect(() => {
        let varOnlyData = {};
        if (selectedOption === "terminal") {
            varOnlyData = {
                type: 'terminal',
                model: terminalDetails.model,
                serial: terminalDetails.serialNumber
            };
        } else if (selectedOption === "gateway") {
            varOnlyData = {
                type: 'gateway',
                model: gatewayName
            };
        }
        setVarOnly(varOnlyData);
    }, [selectedOption, terminalDetails, gatewayName]);

    const handleOptionChange = (e) => {
        setSelectedOption(e.target.value);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (selectedOption === "terminal") {
            setTerminalDetails(prev => ({ ...prev, [name]: value }));
        } else if (selectedOption === "gateway") {
            setGatewayName(value);
        }
    };

    return (
        <>
            <div className="equipments-section mt-2r">
                <h6 className="sub-heading">VAR Only</h6>
                <div className="equipment-box">
                    <div className="eqp-row">
                        <div className="input-wrapper">
                            <label htmlFor="var-option">Select Option</label>
                            <select
                                id="var-option"
                                value={selectedOption}
                                onChange={handleOptionChange}
                            >
                                <option value="">Select</option>
                                <option value="terminal">Terminal</option>
                                <option value="gateway">Gateway</option>
                            </select>
                        </div>

                        {selectedOption === "terminal" && (
                            <>
                                <div className="input-wrapper">
                                    <label htmlFor="terminal-model">Model</label>
                                    <input
                                        type="text"
                                        id="terminal-model"
                                        name="model"
                                        value={terminalDetails.model}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="input-wrapper">
                                    <label htmlFor="serial-number">Serial Number</label>
                                    <input
                                        type="text"
                                        id="serial-number"
                                        name="serialNumber"
                                        value={terminalDetails.serialNumber}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </>
                        )}

                        {selectedOption === "gateway" && (
                            <div className="input-wrapper">
                                <label htmlFor="gateway-name">Gateway Name</label>
                                <input
                                    type="text"
                                    id="gateway-name"
                                    value={gatewayName}
                                    onChange={handleInputChange}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}